(function(Loader, LoadersManager) {
	'use strict';

	var DcyLoadingController = function ($scope, $element, $attrs, $parse) {
		var ctrl = this;

		var loadersManager = LoadersManager.getInstance();
		
		ctrl.loader = new Loader($scope, $element[0]);
		
		if($attrs.dcyComponentId){
			$attrs.$observe('dcyComponentId', function (value) {
                if (value) {
                	self.dcyComponentId = value;
                	loadersManager.registerLoaderById(ctrl.loader, $attrs.dcyComponentId);
                }
            });
		}
		
		$scope.$on('destroy', function(){
			if(ctrl.dcyComponentId){
				loadersManager.deRegisterLoaderById($attrs.dcyComponentId);
			}
		});
		
		$scope.$watch('isEnabled', function(newValue, oldValue){
			if(!angular.equals(newValue, oldValue)){
				if(newValue){
					ctrl.loader.setEnable();
				}
				else{
					ctrl.loader.setDisable();
				}
			}
		});
		
		$scope.$watch('valueMode', function(newValue, oldValue){
			if(!angular.equals(newValue, oldValue)){
				ctrl.loader.setValueMode(newValue);
			}
		});
	};
	
	DcyLoadingController.$inject = ['$scope', '$element', '$attrs', '$parse'];
	
	function DcyLoadingSpinner($compile) {
		return {
			restrict: 'AE',
			scope: {
				isEnabled 	: '=isEnabled', //enabled
				valueMode	: '=valueMode',
				cssClass  	: '@cssClass',
				typeMode 	: '@typeMode',
				diameter 	: '@diameter'
			},
			controller	: DcyLoadingController,
			controllerAs : 'ctrl',
			link: function ($scope, $element, $attrs) {
				var $spinner = angular.element('<loader class="dcy_loading_spinner {{ctrl.loader.getCssClass()}}" ng-if="ctrl.loader.isEnabled()"><md-progress-circular md-mode="{{ctrl.loader.getTypeMode()}}" value="{{ctrl.loader.getValueMode()}}" md-diameter="{{ctrl.loader.getDiameter()}}"></md-progress-circular></loader>');
				$element.append($compile($spinner)($scope));
			}
		};
	}
	
	DcyLoadingSpinner.$inject = ['$compile'];

	angular
	.module('dcyApp')
	.register
	.directive('dcyLoadingSpinner', DcyLoadingSpinner);

}(window.Loader, window.LoadersManager));